<template>
  <v-card flat class="pa-2">
    <insurance-cart v-model="categtories" />
  </v-card>
</template>

<script>
import { mapState } from "vuex";
import insuranceCart from "./cm/insuranceCart.vue";

export default {
  components: { insuranceCart },
  name: "bInsuranceShow",

  computed: {
    ...mapState("local", ["qr_id"]),
  },

  data() {
    return {
      loading: true,
      categtories: {
        data: [],
        cart: [],
      },
    };
  },

  mounted() {
    this.fetchCategory();
  },

  methods: {
    async fetch() {
      try {
        this.loading = true;
        this.$api
          .get("/insuranceQr", {
            params: { qr_id: this.qr_id, category_id: 2 },
          })
          .then(({ data }) => {
            console.log("---->", data?.data?.[0]["category"]);

            // this.categtories.data = [...data?.data?.[0]["category"]];
          });
      } catch {
      } finally {
        this.loading = false;
      }
    },
    async fetchCategory() {
      try {
        this.loading = true;
        await this.$api.get("/insurances").then(({ data }) => {
          this.categtories.cart = data.data;
          console.log(data.data);
        });
      } catch {
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style></style>
